import { useCart } from "../Context/CartContext";
import { parsePrice } from "../utils/price";
import { Link } from "react-router-dom";

export default function Cart() {
  const { cart, increaseQty, decreaseQty, removeFromCart } = useCart();

  if (cart.length === 0) {
    return (
      <div className="container">
        <h2>Your cart is empty</h2>
      </div>
    );
  }

  const subtotal = cart.reduce((sum, item) => {
    return sum + parsePrice(item.price) * item.quantity;
  }, 0);

  return (
    <div className="container">
      <h1>Your Cart</h1>

      {cart.map((item) => (
        <div key={item.id} className="card">
          <h3>{item.name}</h3>
          <p>{item.price}</p>

          <div className="qty-row">
            <button onClick={() => decreaseQty(item.id)}>-</button>
            <span>{item.quantity}</span>
            <button onClick={() => increaseQty(item.id)}>+</button>
          </div>

          <button
            style={{ marginTop: "10px" }}
            onClick={() => removeFromCart(item.id)}
          >
            Remove
          </button>
        </div>
      ))}

      {/* Subtotal */}
      <div className="cart-summary">
        <h3>Subtotal</h3>
        <p>₹{subtotal}</p>
        <small>Taxes and shipping calculated at checkout</small>
      </div>
      <Link to="/checkout">
        <button className="btn-primary">Proceed to Checkout</button>
      </Link>
    </div>
  );
}
